import { SimplePagedResponse } from '../../lib/models/common-response-types';
import { MarketCapCategory, MarketCapData } from '../../lib/models/fundamental/types';

import {
  MarketCapSortDirection,
  MarketCapSortField,
} from '../../shared_components/MarketCapRadar/MarketCapRadar.constants';

export type MarketCapFetchState = {
  isInitial: boolean;
  loadedCategory: MarketCapCategory;
  selectedCategory: MarketCapCategory;
};

/**
 * Single dispatch decision for the widget. Keying on the loaded category rather than the call
 * status means a pending or failed status never re-triggers the fetch, so a filter change fires
 * one request pair and an error does not retry in a loop.
 */
export const shouldFetchMarketCaps = ({ isInitial, loadedCategory, selectedCategory }: MarketCapFetchState): boolean =>
  isInitial || loadedCategory !== selectedCategory;

export const sortMarketCapRows = (
  rows: MarketCapData[],
  sortField: MarketCapSortField | null,
  sortDirection: MarketCapSortDirection,
): MarketCapData[] => {
  if (!sortField) {
    return rows;
  }

  const direction = sortDirection === 'asc' ? 1 : -1;

  return [...rows].sort((a, b) => ((a[sortField] ?? 0) - (b[sortField] ?? 0)) * direction);
};

/** The direction a header cell points at, or `null` when the table is not sorted by it. */
export const hasMoreMarketCapPages = (page: SimplePagedResponse<MarketCapData>): boolean => {
  const readElements = Math.min((page.number + 1) * page.size, page.totalElements);

  return readElements < page.totalElements && page.content.length === readElements;
};
